<header>
  <title>AQMeshData {{environmentName === 'Live' ? '' : environmentName}}</title>
  <div class="p-grid">
    <div class="p-col-12">
      <a id="aqLink" href="https://www.aqmesh.com/" target="_blank" class="pr" style="display:inline-block;">
        <div id="envName" *ngIf="environmentName !== 'Live'"><strong>{{environmentName}}</strong></div>
        <img src="../assets/aq-mesh-data-logo.png" width="100%" />
      </a>
    </div>
  </div>
</header>
